export default {
  "logsOptions": [
    {
      "label": "ERROR.LOG",
      "value": "error"
    },
    {
      "label": "ACCESS.LOG",
      "value": "access"
    },
    {
      "label": "PHP-FPM.LOG",
      "value": "php"
    }
  ],
  "statusOptions": [
    {
      "label": "1000",
      "value": 1000
    },
    {
      "label": "2000",
      "value": 2000
    },
    {
      "label": "3000",
      "value": 3000
    }
  ]
};
